import { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import type { ISiteOption } from "@/customTypings/customer/Customer";

export type ChangeDefaultsSiteModalProps = {
    show: boolean;
    currentSiteId: string;
    eligibleSites: ISiteOption[];
    onCancel: () => void;
    onSelect: (siteId: string) => void;
};

export function ChangeDefaultsSiteModal({
    show,
    currentSiteId,
    eligibleSites,
    onCancel,
    onSelect,
}: ChangeDefaultsSiteModalProps) {
    const selectableSites = eligibleSites.filter((s) => s.id !== currentSiteId);
    const [selectedSiteId, setSelectedSiteId] = useState("");

    useEffect(() => {
        if (!show) {
            setSelectedSiteId("");
            return;
        }
        if (selectableSites.length === 1) {
            setSelectedSiteId(selectableSites[0].id);
        }
    }, [show, selectableSites]);

    return (
        <Modal show={show} onHide={onCancel} centered>
            <Modal.Header closeButton>
                <Modal.Title>Change Site</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group>
                    <Form.Label htmlFor="change-defaults-site">Site</Form.Label>
                    <Form.Select
                        id="change-defaults-site"
                        value={selectedSiteId}
                        onChange={(e) => setSelectedSiteId(e.target.value)}
                    >
                        <option value="">Select site…</option>
                        {selectableSites.map((site) => (
                            <option key={site.id} value={site.id}>
                                {site.siteName}
                            </option>
                        ))}
                    </Form.Select>
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onCancel}>
                    Cancel
                </Button>
                <Button variant="primary" disabled={!selectedSiteId} onClick={() => onSelect(selectedSiteId)}>
                    Select
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
